module.exports = __webpack_public_path__ + "img/logo-maif.3bf05196.webp";